import {AnyAction} from 'redux';
import {
    AuthorEntirePollResponse,
    AuthorPollResponse,
    BtPoll,
    EntirePoll,
    QuestionExt,
    Questions,
    ScriptQuestSets,
    Scripts,
    StoreActionsEnum
} from '../../../modules/hbs-services';
import {ActionEffect} from '../../../modules/hbs-services/classes/common.classes';

export class PollActions {

    static NONE(): AnyAction {
        return {type: StoreActionsEnum.NONE};
    }

    /**
     *  Poll
     */

    static loadEntirePoll(pollId: number): AnyAction {
        return {type: StoreActionsEnum.LOAD_ENTIRE_POLL, payload: {pollId: pollId}};
    }

    static entirePollLoaded(poll: EntirePoll): AnyAction {
        return {type: StoreActionsEnum.ENTIRE_POLL_LOADED, payload: poll};
    }

    static btPollLoaded(btPollResponse: AuthorPollResponse): AnyAction {
        return {type: StoreActionsEnum.BTPOLL_LOADED, payload: {poll: btPollResponse}};
    }

    static updateBtPoll(btPoll: BtPoll, updateAllFields: boolean, effect: ActionEffect): AnyAction {
        return {type: StoreActionsEnum.UPDATE_BTPOLL, payload: {poll: btPoll, pollId: btPoll.pollId, updateAllFields: updateAllFields, effect: effect}};
    }

    static publishPoll(pollId: number): AnyAction {
        return {type: StoreActionsEnum.PUBLISH_POLL, payload: {pollId: pollId}};
    }

    static pollPublished(pollId: number): AnyAction {
        return {type: StoreActionsEnum.POLL_PUBLISHED, payload: {pollId: pollId}};
    }

    static unpublishPoll(pollId: number): AnyAction {
        return {type: StoreActionsEnum.UNPUBLISH_POLL, payload: {pollId: pollId}};
    }

    static pollUnpublished(pollId: number): AnyAction {
        return {type: StoreActionsEnum.POLL_UNPUBLISHED, payload: {pollId: pollId}};
    }

    static deletePoll(pollId: number): AnyAction {
        return {type: StoreActionsEnum.DELETE_POLL, payload: {pollId: pollId}};
    }

    static pollDeleted(pollId: number): AnyAction {
        return {type: StoreActionsEnum.POLL_DELETED, payload: {pollId: pollId}};
    }

    static resetPoll(): AnyAction {
        return {type: StoreActionsEnum.RESET_POLL};
    }

    static deletePollResults(pollId: number) : AnyAction {
        return {type: StoreActionsEnum.DELETE_POLL_RESULTS, payload: {pollId: pollId}};
    }

    static pollResultsDeleted(pollId: number): AnyAction {
        return {type: StoreActionsEnum.POLL_RESULTS_DELETED, payload: {pollId: pollId}};
    }

    static insertBtPoll(poll : BtPoll, isPublic: boolean): AnyAction {
        return {type: StoreActionsEnum.INSERT_BTPOLL, payload: {poll: poll, isPublic: isPublic}};
    }

    static pollInserted(poll: AuthorEntirePollResponse): AnyAction {
        return {type: StoreActionsEnum.POLL_INSERTED, payload: poll.record};

    }



    /**
     *  Questions
     */

    static updateQuestions(questions: QuestionExt[], pollId: number, options: any): AnyAction {
        return {type: StoreActionsEnum.UPDATE_QUESTIONS, payload: {questions: questions, pollId: pollId, options: options}};
    }

    static replaceAllQuestionsAndScriptQuestSets(questions: QuestionExt[], scriptQuestSets: any,
                                                 questNumPairs: any[], keepResponses: boolean, pollId: number, options: any): AnyAction {
        return {
            type: StoreActionsEnum.REPLACE_ALL_QUESTIONS_AND_SCRIPTQUESTSETS,
            payload: {questions: questions, scriptQuestSets: scriptQuestSets,
                questNumPairs: questNumPairs, keepResponses: keepResponses, pollId: pollId, options: options}
        };
    }


    static questionsUpdated(questions: Questions): AnyAction {
        return {type: StoreActionsEnum.QUESTIONS_UPDATED, payload: {questions: questions}};
    }

    static allQuestionsAndScriptQuestSetsReplaced(payload: any): AnyAction {
        const payloadExt = payload; // Object.assign(payload, {select: 'questions'});
        return {type: StoreActionsEnum.ALL_QUESTIONS_AND_SCRIPTQUESTSETS_REPLACED, payload: payloadExt};
    }

    static deleteQuestions(questNums: number[], pollId: number): AnyAction {
        return {type: StoreActionsEnum.DELETE_QUESTIONS, payload: {questNums: questNums, pollId: pollId}};
    }

    static questionsDeleted(payload: any): AnyAction {
        const payloadExt = payload; // Object.assign(payload, {select: 'questions'});
        return {type: StoreActionsEnum.QUESTIONS_DELETED, payload: payload};
    }

    /**
     *  ScriptQuestSets
     */

    static replaceAllScriptQuestSetsAction(scriptQuestSets: ScriptQuestSets,
                                           questNumPairs: any[], keepResponses: boolean, pollId: number): AnyAction {
        return {
            type: StoreActionsEnum.UPDATE_ALL_SCRIPTQUESTSETS,
            payload: {scriptQuestSets: scriptQuestSets,
                questNumPairs: questNumPairs, keepResponses: keepResponses, pollId: pollId}
        };
    }

    static scriptQuestSetsUpdated(scriptQuestSets: ScriptQuestSets, pollId: number): AnyAction {
        return {type: StoreActionsEnum.SCRIPTQUESTSETS_UPDATED, payload: {scriptQuestSets: scriptQuestSets}};
    }

    static replaceAllScriptsAndScriptQuestSetsAction(scripts: Scripts, scriptQuestSets: ScriptQuestSets,
                                                     questNumPairs: any[], keepResponses: boolean, pollId: number) {
        return {
            type: StoreActionsEnum.REPLACE_ALL_SCRIPTS_AND_SCRIPTQUESTSETS,
            payload: {scripts: scripts, scriptQuestSets: scriptQuestSets,
                questNumPairs: questNumPairs, keepResponses: keepResponses, pollId: pollId}
        };
    }

    static emailResponsesToMeAction(pollId: number) {
        return {
            type: StoreActionsEnum.EMAIL_RESPONSES_TO_ME,
            payload: {pollId: pollId}
        };
    }

    static copyPollAction(pollId: number, newTitle: string) {
        return {
            type: StoreActionsEnum.COPY_POLL,
            payload: {pollId: pollId, title: newTitle}
        };

    }

    static lastPollListLinkAction(link: any) {
        return {
            type: StoreActionsEnum.LAST_POLL_LIST_LINK,
            payload: link
        };

    }

    static changePollAudienceAction(pollId: number, makePublic: boolean) {
        return {
            type: StoreActionsEnum.CHANGE_POLL_AUDIENCE,
            payload: {pollId: pollId, makePublic: makePublic}
        };
    }
}
